<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-btn
      color="success"
      class="text-capitalize"
      block
      rounded
      @click="$emit('approval:approve')"
    >
      <v-icon
        left
        small
      >
        check
      </v-icon>
      Approve Deal
    </v-btn>
    <v-btn
      color="error"
      class="text-capitalize"
      block
      rounded
      text
      @click="$emit('approval:reject')"
    >
      <v-icon
        left
        small
      >
        close
      </v-icon>
      Reject Deal
    </v-btn>
  </div>
</template>

<script>
  import Yacht from '@/models/Yacht'

  export default {
    name: 'Approval',
    props: {
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        yachtStatuses: Yacht
      }
    }
  }
</script>
